var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3622 3.15526C10.5526 3.35527 10.5448 3.67176 10.3447 3.86215L4.56697 9.36215C4.4683 9.45608 4.33558 9.50568 4.1995 9.49948C4.06341 9.49329 3.93575 9.43184 3.84602 9.32934L1.6238 6.79088C1.44191 6.58311 1.46289 6.26722 1.67066 6.08533C1.87844 5.90344 2.19433 5.92442 2.37622 6.1322L4.25507 8.27842L9.65527 3.13785C9.85528 2.94745 10.1718 2.95525 10.3622 3.15526Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.3083ced191737a115007f4851053f453.svg";
export { ForwardRef as ReactComponent };